import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";

interface LoginCheckResponse {
  is_authenticated: boolean;
  error : string | null;
  isLoading : boolean;

}

export interface iLoginCheckState {
  response : LoginCheckResponse;
  isLoading: boolean;
}

const initialResponse: LoginCheckResponse = {
  is_authenticated: false,
  error: null,  
  isLoading: false,
};

const initialState: iLoginCheckState = {
  response: initialResponse,
  isLoading: false,
};

// 로그인 체크 API 호출
export const loginCheckAPI = createAsyncThunk(
  "LOGIN_CHECK",
  async (_, { rejectWithValue }) => {
    try {
      const djangoEndpoint = getDjangoEndpoint();
      const pathParam = '/auth/login-check/';

      if (!djangoEndpoint) {
        throw new Error("Django endpoint not found");
      }

      const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// 슬라이스 코드
export const loginCheckSlice = createSlice({
  name: "loginCheck",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginCheckAPI.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loginCheckAPI.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(loginCheckAPI.rejected, (state, action) => {
        state.isLoading = false;
        console.error("Login check failed:", action.payload);
      });
  },
});

export default loginCheckSlice.reducer;